import * as React from 'react';

const TrashCircle = ({ stroke, ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#005AFF"
      stroke="#005AFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M12.5 22.001c5.524 0 10.001-4.477 10.001-10 0-5.524-4.477-10.001-10-10.001C6.977 2 2.5 6.477 2.5 12c0 5.524 4.477 10.001 10 10.001Z"
    />
    <path
      stroke="#F9F9F9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M9.41 12v4.383c0 .409.208.618.636.618h4.909c.418 0 .627-.21.636-.618V12M8.027 8.845h8.946M12.5 7V8.58"
    />
  </svg>
);

export default TrashCircle;
